import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { Collapse, Container, Nav, Navbar, NavbarBrand, NavbarToggler } from 'reactstrap';
import handleNavbarTransparency from '../../helpers/handleNavbarTransparency';
import NavbarTopDropDownMenusLanding from './NavbarTopDropDownMenusLanding';
import LandingRightSideNavItem from './LandingRightSideNavItem';
import { topNavbarBreakpoint } from '../../config';
import Logo from './Logo';

const NavbarStandard = () => {
  const [navbarCollapsed, setNavbarCollapsed] = useState(true);

  useEffect(() => {
    window.addEventListener('scroll', handleNavbarTransparency);
    return () => window.removeEventListener('scroll', handleNavbarTransparency);
  }, []);

  return (
    <Navbar dark fixed="top" expand={topNavbarBreakpoint} className={classNames('navbar-standard navbar-theme')}>
      <Container>
        <NavbarBrand className="d-flex align-items-center justify-content-center text-white" tag="div">
          <Logo at="navbar-top" bordered width={120} id="topLogo" />
        </NavbarBrand>
        <NavbarToggler onClick={() => setNavbarCollapsed(!navbarCollapsed)} />
        <Collapse isOpen={!navbarCollapsed} navbar className="scrollbar">
          <Nav navbar className="scrollbar">
            <NavbarTopDropDownMenusLanding setNavbarCollapsed={setNavbarCollapsed} />
          </Nav>
        </Collapse>
        <Collapse isOpen={!navbarCollapsed} navbar className="scrollbar">
          <LandingRightSideNavItem />
        </Collapse>
      </Container>
    </Navbar>
  )
}

export default NavbarStandard;